<template><div><p class="d-docsite--paragraph">Check out our <RouteLink to="/design/illustrations/" class="d-docsite--link d-link">illustration catalog</RouteLink>, and our <RouteLink to="/design/brand/" class="d-docsite--link d-link">brand section</RouteLink> for information on how to use this component.</p>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="icon" /></div></template>


